import React, {useEffect} from "react";
import IconTick from "../../assets/v2/check-circle.png";
import IconCross from "../../assets/v2/x-circle.png";
import IconMailTick from "../../assets/v2/check-mail.png";
import IconMailCross from "../../assets/v2/check-mail.png";
import {twMerge} from "tailwind-merge";

interface AlertProps {
}

export const INFO = 'info';
export const SUCCESS = 'success';
export const ERROR = 'error';

export const MAIL_SUCCESS = 'mail-success';
export const MAIL_ERROR = 'mail-error';

export default function Alert({
                                  label,
                                  text,
                                  type = INFO,
                                  closeHandler = null,
                                  ...rest // Collect remaining props
                              }: AlertProps) {

    let typeClass = "";
    let typeIcon = null;
    switch (type) {
        case SUCCESS:
            typeClass = "bg-[#00ae11]"
            typeIcon = IconTick;
            break;
        case ERROR :
            typeClass = "bg-[#cd311e]"
            typeIcon = IconCross;
            break;
        case MAIL_SUCCESS:
            typeClass = "bg-[#00ae11]"
            typeIcon = IconMailTick;
            break;
        case MAIL_ERROR :
            typeClass = "bg-[#cd311e]"
            typeIcon = IconMailCross;
            break;
    }

    return (
        <div>
            <div className={twMerge("p-4 text-sm text-white rounded-lg flex gap-3 items-center", typeClass)}
                 role="alert">
                <img className="h-[24px] w-[24px]" src={typeIcon} alt="car"/>
                <div className="grow">
                    <div className=""><b>{label}</b></div>
                    <div className="">{text}</div>
                </div>
                {closeHandler ?
                    <div>
                        <img className="" src={IconCross} onClick={(e) => closeHandler()} alt="car"/>
                    </div>
                    : null}
            </div>
        </div>);
};